import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Circle, BackArrow } from '../../assets/svg/icons'
import { BackToButton } from '../../styles/globalStyles'

const BackButton = ({ label, handle, type }) => {
  return (
    <BackToButton
      className={type}
      onClick={() => handle()}
      aria-label={label}>
      <Circle />
      <div>
        <BackArrow className='arrow' />
      </div>
    </BackToButton>
  )
}

BackButton.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  handle: PropTypes.func.isRequired
}

export default memo(BackButton)
